import { useState } from 'react';

import SkeletonCard from '../../components/cards/SkeletonCard';
import { Box, Button, Typography, useTheme } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import ExoDialog from '../../components/exo/ExoDialog';
import { NewMeeting } from '../../components/new/NewMeeting';
import { NewInteraction } from '../../components/new/NewInteraction';
import moment from 'moment';
import { NewInteractionNote } from '../../components/new/NewInteractionNote';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ForumIcon from '@mui/icons-material/Forum';
import AddTaskIcon from '@mui/icons-material/AddTask';
import { NewTask } from '../../components/new/NewTask';
import uuid from 'react-uuid';

export const ProjectQuickActions = ({
  data,
  isLoading,
  type,
  typePlural,
  name,
  onFeedback,
  onMeetingChange,
  onInteractionChange,
  onTaskChange,
  noTasks,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(null);

  const [openParticipantsBlockTimes, setOpenParticipantsBlockTimes] =
    useState(false);

  // event
  function handleOpenNewEvent() {
    setOpen('meeting');
  }

  // interaction
  function handleOpenInteraction() {
    setOpen('interaction');
  }

  // interaction note
  function handleOpenInteractionNote() {
    setOpen('note');
  }

  // taksk
  function handleOpenTask() {
    setOpen('task');
  }

  if (isLoading) return <SkeletonCard span={3} />;
  const meetingStartData = () => {
    return {
      label: `${t('Meeting with')} ${name}`,
      reminders: [
        {
          remindAt: moment().subtract(1, 'days'),
          uuid: uuid(),
          type: 'minutesBefore',
          value: 15,
        },
      ],
      project: data,
    };
  };

  const interactionNoteStartData = {
    dateTime: moment().toISOString(),
    type: 'note',
    project: data,
  };

  const interactionStartData = {
    dateTime: moment().toISOString(),
    type: 'call',
    project: data,
  };

  return (
    <>
      <Box className="flex items-start justify-center gap-2">
        <QuickActionButton
          Icon={EventIcon}
          label={t('Event')}
          onClick={handleOpenNewEvent}
        />
        <QuickActionButton
          Icon={EditNoteIcon}
          label={t('Note')}
          onClick={handleOpenInteractionNote}
        />
        <QuickActionButton
          Icon={ForumIcon}
          label={t('Protocol')}
          onClick={handleOpenInteraction}
        />
        {!noTasks && (
          <QuickActionButton
            Icon={AddTaskIcon}
            label={t('Task')}
            onClick={handleOpenTask}
          />
        )}
      </Box>
      <ExoDialog
        open={open === 'meeting'}
        onClose={() => setOpen(null)}
        limitWidth
        maxWidth={openParticipantsBlockTimes ? '1200px' : '800px'}
      >
        <NewMeeting
          startData={meetingStartData()}
          onClose={() => {
            setOpen(null);
            setOpenParticipantsBlockTimes(false);
          }}
          onFeedback={onFeedback}
          onCreate={onMeetingChange}
          onUpdate={onMeetingChange}
          openParticipantsBlockTimes={openParticipantsBlockTimes}
          setOpenParticipantsBlockTimes={setOpenParticipantsBlockTimes}
        />
      </ExoDialog>
      <ExoDialog
        open={open === 'interaction'}
        onClose={() => setOpen(null)}
        limitWidth
      >
        <NewInteraction
          startData={interactionStartData}
          onClose={() => setOpen(null)}
          onFeedback={onFeedback}
          onCreate={onInteractionChange}
          onUpdate={onInteractionChange}
        />
      </ExoDialog>
      <ExoDialog
        open={open === 'note'}
        onClose={() => setOpen(null)}
        limitWidth
      >
        <NewInteractionNote
          startData={interactionNoteStartData}
          onClose={() => setOpen(null)}
          onFeedback={onFeedback}
          onCreate={onInteractionChange}
          onUpdate={onInteractionChange}
        />
      </ExoDialog>
      <ExoDialog
        open={open === 'task'}
        onClose={() => setOpen(null)}
        limitWidth
      >
        <NewTask
          onClose={() => setOpen(null)}
          onFeedback={onFeedback}
          onCreate={onTaskChange}
          onUpdate={onTaskChange}
          targetId={data?.id}
          targetType={type}
        />
      </ExoDialog>
    </>
  );
};

const QuickActionButton = ({ onClick, Icon, label }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Button
      color="secondary"
      variant="contained"
      disableElevation
      onClick={onClick}
      sx={{
        width: '85px',
        height: '85px',
        bgcolor: colors.bgInput,
        ':hover': {
          bgcolor: colors.selected,
        },
        padding: '0px!important',
      }}
    >
      <Box className="h-full w-full flex items-center justify-center flex-col gap-1">
        <Icon
          sx={{
            fontSize: '40px',
          }}
        />
        <Typography fontSize="13px">{label}</Typography>
      </Box>
    </Button>
  );
};
